<ul [ngStyle]="colorList"
    class="color-button-container">
    <li (click)="onColorClick(color)"
        *ngFor="let color of legend"
        [ngClass]="{
        'active': internalSelected?.colorID === color?.colorID,
        'disabled':readOnly
    }"
        class="color-button">
        <div [ngStyle]="{
                 'background-color': color.color === 'url(#obl1)' ? null : (color.color || 'white'),
                 'background-image': getPatternBg(color.color)
             }"
             class="color-button-circle">
        </div>
        <p class="color-button-label">
            <span class="label-text">{{ color.alphaCode }}. {{ color.description }}</span>
            <span class="hidden-label-text-for-spacing">{{ color.alphaCode }}. {{ color.description }}</span>
        </p>
    </li>
</ul>

<div [ngClass]="{'button-container--gutter': isWithButtons && legend.length>0}" class="buttons-container">
    <div *ngIf="isWithButtons"
         class="legend-button-container">
        <legend-button
            (buttonClick)="onButtonClick($event.clickValue)"
            *ngFor="let btn of parsedButtonsConfiguration"
            [buttonConfig]="btn"
            [disabled]="readOnly"
        >
        </legend-button>
    </div>
    <ng-content select="[extra-buttons-before]"></ng-content>
</div>
